import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'Agent Chat generates a new edit on the canvas',
  name: 'canvas_agent_chat_edit_generated',
  params: [
    {
      description: 'The width of the generated image',
      name: 'width',
      required: true,
      type: 'number',
    },
    {
      description: 'The height of the generated image',
      name: 'height',
      required: true,
      type: 'number',
    },
    {
      description: 'The content type of the generated image',
      name: 'content_type',
      required: true,
      type: 'string',
    },
    {
      description: 'The ID of the canvas',
      name: 'canvas_id',
      required: true,
      type: 'string',
    },
    {
      description: 'The ID of the chat thread',
      name: 'thread_id',
      required: false,
      type: 'string',
    },
    {
      description: 'Whether the model selection is in auto mode',
      name: 'is_auto',
      required: false,
      type: 'boolean',
    },
    {
      description: 'The name of the model selected manually by the user (only present when is_auto is false)',
      name: 'model_selected_manually',
      required: false,
      type: 'string',
    },
  ],
};

export default META;
